import React from 'react';
import { connect } from 'react-redux';
import { IChangeLog } from '../../../definitions/interfaces/IChangelog';
import { ILocalization } from '../../../localization/definitions/types';
import { RootState } from '../../../store';
interface IProps {
    changeLog: IChangeLog;
    localization: ILocalization;
}

interface Update {
    headline: string;
    description?: string;
}

class ChangeLogItemBody extends React.Component<IProps> {
    renderUpdatesBody = (updates: Array<Update>) => {
        return updates.map((update, index) => (
            <li key={index}>
                <p className={'update-content-headline'}>
                    <b>{update.headline}</b>
                </p>
                <span className={'update-content-description'}>
                    {update.description}
                </span>
            </li>
        ));
    };

    renderUpdates = () => {
        const updateTypes = [
            'generalChanges',
            'userChanges',
            'supervisorChanges',
            'adminChanges',
            'otherChanges',
        ];
        return updateTypes.map((updateType, index) => {
            return this.props.changeLog[updateType]?.length ? (
                <div key={index}>
                    <p className={'update-role-text'}>
                        {
                            this.props.localization.localizationStrings.susy
                                .help.changeLogItemBody[updateType]
                        }
                    </p>
                    <ul>
                        {this.renderUpdatesBody(
                            this.props.changeLog[updateType]
                        )}
                    </ul>
                </div>
            ) : null;
        });
    };

    render() {
        return (
            <>
                <div className={'changes-wrapper'}>{this.renderUpdates()}</div>
            </>
        );
    }
}

const mapStateToProps = (state: RootState) => {
    return {
        localization: state.localization,
    };
};

export default connect(mapStateToProps)(ChangeLogItemBody);
